const FormField = ({ label, htmlFor, error, hint, required = false, children, className = '' }) => (
  <div className={`mb-4 ${className}`}>
    {label && (
      <label className="form-label" htmlFor={htmlFor}>
        {label}
        {required && (
          <span className="ml-1 text-danger-500" aria-hidden="true">
            *
          </span>
        )}
      </label>
    )}
    {children}
    {hint && !error && (
      <p className="mt-1 text-sm text-theme-secondarytextcolor dark:text-themedark-secondarytextcolor">{hint}</p>
    )}
    {error && <p className="error-message">{error}</p>}
  </div>
);

export default FormField;
